<template>

    <b-card>

        <edit-client @refreshUserList="refreshUserList()" ref="modalEditClientC"></edit-client>

        <transaction-modal ref="clientViewTransaction"></transaction-modal>

        <all-balance ref="allBalanceC"></all-balance>

        <b-row>

            <!-- Client Info: Left col -->
            <b-col
                    cols="21"
                    xl="6"
                    class="d-flex flex-column"
            >
                <!-- Client Avatar & Action Buttons -->
                <div class="d-flex justify-content-start align-items-center">
                    <b-avatar
                            :src="clientData.avatar"
                            :text="this.avatarText(clientData.name)"
                            :variant="`light-primary`"
                            size="104px"
                            rounded
                    />
                    <div class="d-flex flex-column ml-1">

                        <div class="mb-1">
                            <h4 class="mb-0">
                                {{ `${clientData.name}` }}
                            </h4>
                            <span class="card-text">{{ clientData.description }}</span>
                        </div>

                        <div class="d-flex flex-wrap">
                            <b-button v-if="$can('edit','Client')"
                                      @click="ediClient()"
                                      variant="primary"
                                      size="sm"
                            >
                              {{$t('labels.edit')}}
                            </b-button>

                            <b-button v-if="$can('delete','Client')"
                                      @click="deleteClient()"
                                      variant="outline-danger"
                                      class="ml-1"
                                      size="sm"
                            >
                              {{ $t('labels.delete') }}
                            </b-button>
                        </div>
                    </div>
                </div>

                <!-- Client Stats -->
<!--                <div class="d-flex align-items-center mt-2">-->

<!--                    <div class="d-flex align-items-center mr-2">-->
<!--                        <b-avatar variant="light-primary"-->
<!--                                rounded-->
<!--                        >-->
<!--                            <feather-icon-->
<!--                                    icon="DollarSignIcon"-->
<!--                                    size="18"-->
<!--                            />-->
<!--                        </b-avatar>-->
<!--                        <div class="ml-1">-->
<!--                            <h5 class="mb-0">-->
<!--                                23.3k-->
<!--                            </h5>-->
<!--                            <small>Wallet Balance</small>-->
<!--                        </div>-->
<!--                    </div>-->

<!--                    <div class="d-flex align-items-center">-->
<!--                        <b-avatar-->
<!--                                variant="light-success"-->
<!--                                rounded-->
<!--                        >-->
<!--                            <feather-icon-->
<!--                                    icon="TrendingUpIcon"-->
<!--                                    size="18"-->
<!--                            />-->
<!--                        </b-avatar>-->
<!--                        <div class="ml-1">-->
<!--                            <h5 class="mb-0">-->
<!--                                $99.87k-->
<!--                            </h5>-->
<!--                            <small>Profits</small>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->

            </b-col>

            <!-- Right Col: Table -->
            <b-col
                    cols="12"
                    xl="6"
            >
                <table class="mt-2 mt-xl-0 w-100">

                    <tr>
                        <th class="pb-50">
                            <feather-icon
                                    icon="CheckIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.status')}}</span>
                        </th>
                        <td class="pb-50 text-nowrap">
                            {{ clientData.status ? $t("labels.activeStatus") : $t("labels.inactiveStatus") }}
                        </td>
                    </tr>

                    <tr v-if="!Number.isNaN(clientData.tax)">
                        <th class="pb-50">
                            <feather-icon
                                    icon="DollarSignIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.tax')}}</span>
                        </th>
                        <td class="pb-50">
                            {{ `${clientData.tax}` }}
                        </td>
                    </tr>

                    <tr v-if="clientData.users">
                        <th class="pb-50">
                            <feather-icon
                                    icon="UsersIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.users')}}</span>
                        </th>
                        <td class="pb-50">
                            {{ `${clientData.users.length}` }}
                        </td>
                    </tr>

                    <tr v-if="clientData.publicKey">
                        <th class="pb-50">
                            <feather-icon
                                    icon="KeyIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.publicKey')}}</span>
                        </th>
                        <td class="pb-50" @click="copyPublicKey()">
                            <b-badge class="d-flex align-items-center justify-content-between" style="max-width: 230px"
                                      variant="success">
                                <div style="max-width: 200px; white-space: nowrap; text-overflow: ellipsis;overflow: hidden"
                                     ref="publicKey">
                                    {{ `${clientData.publicKey}` }}
                                </div>
                                <feather-icon
                                        icon="CopyIcon"
                                />
                            </b-badge>

                        </td>
                    </tr>

                    <!-- TODO REMOVE (WALLET 2.0)
                    <tr v-if="$can('read','ClientOperations')" @click="showClientTransaction(clientData)">
                        <th class="pb-50">
                            <feather-icon
                                    icon="BookmarkIcon"
                                    class="mr-75"
                            />
                            <span class="font-weight-bold">{{$t('labels.clientOperations')}}</span>
                        </th>
                        <td class="pb-50">
                            <b-button variant="danger" size="sm" class="d-flex flex-row ">
                                <span>{{$t('buttons.showOperations')}}</span>
                            </b-button>
                        </td>
                    </tr>
                    !-->

                    <!-- TODO REMOVE (WALLET 2.0)
                    <tr v-if="$can('read','ClientOperations')" @click="showClientAllBalance(clientData)">
                      <th class="pb-50">
                        <feather-icon
                            icon="ListIcon"
                            class="mr-75"
                        />
                        <span class="font-weight-bold">{{$t('labels.clientBalances')}}</span>
                      </th>
                      <td class="pb-50">
                        <b-button variant="success" size="sm" class="d-flex flex-row ">
                          <span>{{$t('buttons.showBalances')}}</span>
                        </b-button>
                      </td>
                  </tr>
                  !-->

                </table>
            </b-col>

        </b-row>

    </b-card>

</template>

<script>
  import { avatarText } from '@/@core/utils/filter'
  import { BAvatar, BButton, BCard, BCol, BRow , BBadge} from 'bootstrap-vue'
  import EditClient from './EditClient'
  import { mapActions } from 'vuex'
  import TransactionModal from '../shared/TransactionModal'
  import AllBalance from "@/views/dashboard/shared/AllBalance";

  export default {
    name: 'UserViewUserInfoCard',
    components: {
      AllBalance,
      TransactionModal,
      BCard, BButton, BRow, BCol, BAvatar,EditClient,BBadge
    },

    props: {
      clientData: {
        type: Object,
        required: true,
      },
    },

    setup() {
      return {
        avatarText,
      }
    },

    data(){
      return{
        currencies : [],
        defaultCurrency : ''
      }
    },

    methods: {
      ...mapActions('client', ['destroy']),
      ...mapActions("wallet", ["show"]),

      showClientTransaction(client){
        this.$refs.clientViewTransaction.showModal(client,this.defaultCurrency,this.currencies,'CLIENT')
      },

      showClientAllBalance(client){
        this.$refs.allBalanceC.showAllBalanceModal(client,'CLIENT')
      },

      getWalletCurrencies(currencies){
        return currencies.map(currencies => {
          return Object.assign({}, currencies.currency)
        })
      },

      ediClient(){
        delete this.clientData.password
        this.$refs.modalEditClientC.showModal(this.clientData)
      },

      async deleteClient() {
        this.$swal({
          title: this.$t('labels.areYouSure'),
          text: this.$t('labels.notRevert'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('labels.yesDelete'),
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        })
          .then(async result => {
            if (result.value) {
              let response = await this.destroy(this.clientData._id)
              if(response){
                this.refreshUserList()
                this.$swal({
                  icon: 'success',
                  title: this.$t('labels.deleted'),
                  text: response.message,
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })
              }
            }
          })
      },

      refreshUserList() {
        this.$router.push({ name: 'clients' })
      },

      async copyPublicKey() {
        try {
          await navigator.clipboard.writeText(this.clientData.publicKey);
          this.$swal({
            icon: 'success',
            title: this.$t('labels.copiedPublicKey'),
            text: this.$t('labels.copiedPublicKeyClipboard'),
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        } catch($e) {
          this.$swal({
            icon: 'error',
            title: this.$t('labels.error'),
            text: this.$t('labels.copiedPublicKeyClipboardError'),
            customClass: {
              confirmButton: 'btn btn-danger',
            },
          })
        }
      }

    },

    async created() {
      const clientCurrencies  = this.clientData.currencies
      if (clientCurrencies){
        this.currencies = this.getWalletCurrencies(clientCurrencies).filter(currency => currency.status)
        this.defaultCurrency =  this.clientData.defaultCurrency
      }
    }

  }
</script>

<style>
</style>
